export default __webpack_public_path__ + "static/media/degreeplanner.bf998037.png";